export const RESET_SELECTORS = "RESET_SELECTORS";
export const LOAD_CLIENT_SELECTOR = "LOAD_CLIENT_SELECTOR";
export const CHANGE_CLIENT_SELECTOR = "CHANGE_CLIENT_SELECTOR";
export const LOAD_SITE_SELECTOR = "LOAD_SITE_SELECTOR";
export const CHANGE_SITE_SELECTOR = "CHANGE_SITE_SELECTOR";
export const OPEN_CLOSE_CLIENT_SITE_SELECTOR_ALERT_MODAL = "OPEN_CLOSE_CLIENT_SITE_SELECTOR_ALERT_MODAL";